import React from 'react'

export const BaseContext = React.createContext({
  color: '',
  onChangeColor: () => { },
  onChangeleftButton: () => { },
})
